import React, { createContext, useContext } from 'react';
import { useCallRTC } from '../hooks/useCallRTC';

// ─────────────────────────────────────────────────────────────────────────
// CallContext — wraps the SINGLE global useCallRTC instance and exposes it
// to the whole app. Mounted once at App root (inside CallProvider), so
// every page (chat pages, global overlay, anywhere) shares the exact same
// peer connection / call state — fixing the old split-brain bug where a
// chat page and GlobalCallOverlay each ran their own independent WebRTC
// engine depending on whether the page happened to be open.
// ─────────────────────────────────────────────────────────────────────────

const CallContext = createContext(null);

export function CallProvider({ children }) {
  const call = useCallRTC();
  return <CallContext.Provider value={call}>{children}</CallContext.Provider>;
}

export function useCall() {
  const ctx = useContext(CallContext);
  if (!ctx) throw new Error('useCall must be used within CallProvider');
  return ctx;
}
